(() => {
  const whatsappNumber = '6285121807917';
  const legacyNumbers = ['6285183216951', '+6285183216951'];
  const rewriteWhatsAppLinks = (root = document) => {
    root.querySelectorAll('a[href]').forEach((link) => {
      const rawHref = link.getAttribute('href') || '';
      const isWhatsApp = /(?:wa\.me|api\.whatsapp\.com|whatsapp\.com\/send)/i.test(rawHref);
      const hasLegacyNumber = legacyNumbers.some((number) => rawHref.includes(number));
      if (!isWhatsApp && !hasLegacyNumber) return;
      try {
        const current = new URL(link.href, window.location.origin);
        const text = current.searchParams.get('text');
        const next = new URL('https://wa.me/' + whatsappNumber);
        if (text) next.searchParams.set('text', text);
        link.href = next.toString();
      } catch (error) {
        link.href = 'https://wa.me/' + whatsappNumber;
      }
    });
  };
  const update = () => rewriteWhatsAppLinks(document);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', update, { once: true });
  } else {
    update();
  }
  new MutationObserver(update).observe(document.documentElement, { childList: true, subtree: true });
})();
